import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'
import _ from 'lodash'

const selectEmployeeWorkday = ( day ) => {
	return (
		createSelector(
			[
				(state) => {
					return state.data[dataConstants.EMPLOYEE]?.workdays;
				},
			],
			( workdays ) => {
				return _.find( workdays, { workday_day: day }) ?? {}
			}
		)
	);
}

export default selectEmployeeWorkday;